import type { CommonMultiPeriodMeta } from 'types/kinerja'
import type { TAtasanStatus } from 'types/kinerja-atasan'
import type {
  TPenetapanRatingPerilakuKerja,
  TPenetapanRatingPraktikKinerja,
} from 'types/kinerja-ks-pelaksanaan'
import type { CommonListResponse, CommonResponse } from 'types/api'

// Objects
export enum DeliveryStatus {
  ALL = 'all',
  SUDAH_DIKIRIM = 'sudahDikirim',
  BELUM_DIKIRIM = 'belumDikirim',
  BELUM_DINILAI = 'belumDinilai',
}

export enum Predicates {
  nilaiSangatBaik = 'nilaiSangatBaik',
  nilaiBaik = 'nilaiBaik',
  nilaiButuhPerbaikan = 'nilaiButuhPerbaikan',
  nilaiKurang = 'nilaiKurang',
  nilaiSangatKurang = 'nilaiSangatKurang',
}

export type TPredicateKey = keyof typeof Predicates
export type TPredicates = Record<TPredicateKey, number>

export type TPenilaian = {
  id: string
  name: string
  jenjang: string
  jabatan?: string
  satuanPendidikan: string
  npsn: string
  predikatKinerja: string
  estimasiAngkaKredit: number
  statePengiriman: 'SUDAH_DIKIRIM' | 'BELUM_DIKIRIM'
  ratingPraktikKinerja: TPenetapanRatingPraktikKinerja
  ratingPerilakuKerja: TPenetapanRatingPerilakuKerja
  poinPengembanganKompetensi: number
  confirmedSubordinate: TAtasanStatus
}

export type TPenilaianTujuanState = 'PS_TO_DINAS' | 'PS_TO_KS' | 'DINAS_TO_KS'

export type TPenilaianMeta = {
  year: number
  counts: {
    all: number
    belumDikirim: number
    sudahDikirim: number
    belumDinilai: number
  }
}

export type TPenilaianFilterStatus = keyof typeof DeliveryStatus

// API Payload
export type TPayloadPenilaianForDelivery = {
  id: TPenilaian['id'][]
  state: TPenilaianTujuanState
}

export type TPayloadPenilaian = {
  id: TPenilaian['id']
  ratingPraktikKinerja: TPenetapanRatingPraktikKinerja
  ratingPerilakuKerja: TPenetapanRatingPerilakuKerja
}

// API Responses
export type TResponsePenilaian = CommonListResponse<
  TPenilaian,
  CommonMultiPeriodMeta & TPenilaianMeta
>

export type TResponsePenilaianSummaryData = Record<TPredicateKey, number> & {
  belumDikirim: number
}

export type TResponsePenilaianSummary = {
  data: TResponsePenilaianSummaryData
}

export type TResponsePenilaianForDelivery = {
  totalSent: number
}

export type TResponsePenilaianCount = CommonResponse<{
  all: number
  belumDikirim: number
  sudahDikirim: number
  belumDinilai: number
}>

export type TResponsePredikatKinerja = CommonListResponse<Partial<TPenilaian>>
